module.exports = __webpack_public_path__ + "assets/img/push.6b54248c.webp";